import { removeMyListItem } from 'containers/CarouselsDisplay/redux/actions/cms.actions';
import {
  showDeleteConfirmationModal,
  setContentName,
  setDeleteCallback,
  setCancelCallback,
  setContentType,
} from 'containers/CarouselsDisplay/redux/actions/deleteConfirmationModal.actions';
import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import { useDispatch } from 'react-redux';
import useMenuRedirect from '../../../../../Menu/hooks/useMenuRedirect';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
import { getRegion } from '../../../../../../utils/Region';
import {PUSHTOHISTORY} from 'constants.js'
//-------------------------------------------------------------------------
import { FadeInImage } from '../../../../../../components/FadeInImage';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';

export const MyListCard = ({
  contentInfo,
  node,
  index,
  contentType,
  carouselSubType,
  carouselTitle,
  contentPosition,
}) => {
  const { renderLabel } = useRenderChapas();
  const dispatch = useDispatch();
  const typeContent =
    carouselSubType !== 'Carrouselvertical' ? contentType : 'favoritedLive';
  const { navigateToChannel, nodesSelected } = useMenuRedirect();
  const navigate = useNavigate();

  const handleCardClick = e => {
    e.stopPropagation();

    const isLiveContent = getContentListV1?.IsLive(contentInfo);
    const groupId = contentInfo?.id;

    pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

    //Redireccionamiento
    if (isLiveContent) return navigateToChannel({ id: groupId }, PUSHTOHISTORY);
    navigate(
      `/${getRegion()}/vcard/homeuser/${getContentListV1?.titleUri(contentInfo)}/${
        contentInfo.id
      }`,
    );
  };

  const handleRemoveListClick = async e => {
    e.stopPropagation();
    // SETEA NOMBRE DE CONTENIDO, TIPO DE CARRUSEL Y MUESTRA MODAL DE CONFIRMACION
    dispatch(setContentName(contentInfo?.title));
    dispatch(setContentType(typeContent));
    dispatch(showDeleteConfirmationModal);
    // SETEA CALLBACK PARA BORRADO
    dispatch(
      setDeleteCallback(() => {
        dispatch(removeMyListItem({ contentId: contentInfo?.id, index, node }));
      }),
    );

    dispatch(setCancelCallback(() => {}));
  };

  return (
    <div className="my-list-card">
      {renderLabel(contentInfo)}
      <div className="my-list-card__poster" onClick={handleCardClick}>
        <FadeInImage
          imageAlt="clarovideo"
          imageSrc={getContentListV1?.getImage(contentInfo,IMG_SIZE?.LARGE)}
          width={258}
          height={145}
          classNames={['my-list-card__image']}
        />
      </div>
      <footer className="my-list-card__footer">
        <span className="my-list-card__footer__title" onClick={handleCardClick}>
          {contentInfo?.title}
        </span>
        <FaRegTrashAlt
          className="my-list-card__footer__icon"
          onClick={handleRemoveListClick}
        />
      </footer>
    </div>
  );
};
